<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">With thanks to Joan Smith</p>
<p style="text-align: center;">and</p>
<p style="text-align: center;">Austin Macauley Publishers</p>
<p style="text-align: center;">for making this possible</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?41f7f269